import { render } from "./BaseTypeApiModelHistory.vue?vue&type=template&id=d72b9170"
import script from "./BaseTypeApiModelHistory.vue?vue&type=script&lang=js"
export * from "./BaseTypeApiModelHistory.vue?vue&type=script&lang=js"

import exportComponent from "/builds/smartcom-gitlab-cis/maap/Application/Frontends/ProSpace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__